<template>
  <div class="admin">
    <div class="admin__header">
      <h1 class="no-margin">Companies</h1>
    </div>
    <div class="company-search">
      <form @submit.prevent="search" class="company-search__form">
        <input type="text" class="company-search__input" placeholder="Search for a company" v-model="term">
        <button type="submit" class="secondary-button">Search</button>
      </form>
      <div class="company-search__message" v-if="orderedCompanies.length > 0 && searchPerformed">
        Found {{ companyCount }}
      </div>
      <div class="company-search__message" v-else-if="searchPerformed">No companies found</div>
    </div>

    <div v-if="searchPerformed">
      <div class="items" v-if="orderedCompanies.length > 0">
        <router-link :to="{ name: 'lawyer-company', params: { companyId: company.id } }"
          v-for="company in orderedCompanies" :key="company.id">
          <div class="item panel">{{ company.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import pluralize from 'pluralize';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'lawyer-companies',

  data() {
    return {
      term: '',
      searchPerformed: false,
    };
  },

  computed: {
    ...mapGetters('lawyer', [
      'orderedCompanies',
    ]),

    companyCount() {
      return `${this.orderedCompanies.length} ${pluralize('company', this.orderedCompanies.length)}`;
    },
  },

  watch: {
    term(value) {
      if (value === '') this.searchPerformed = false;
    },
  },

  methods: {
    ...mapActions('lawyer', [
      'searchCompanies',
    ]),

    search() {
      if (this.term) {
        this.searchCompanies(this.term).then(() => this.searchPerformed = true);
      }
    },
  },
};
</script>
